import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
/**
 * 获取工程师
 */
export const findUserList = (params) => {
  params = parseParam(params)
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/details/search?` + params,
    method: 'GET',
  })
}

/**
 * 获取状态下拉列表，防水报单：
 * @param {*} params
 * @param {*} params.type 订单类型water_proof_declaration是防水订单状态、ceil_declaration是吊顶订单状态、engineering 是工单阶段状态状态
 * @returns {*} 
 */
export const getOrderStatusList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/status_enum/list?` + params,
    method: 'GET',
  })
}
/**
 * 
 * @param {*} params
 * @param {*} params.itemName 费用项目
 * @param {*} params.stageId 阶段id
 * @param {*} params.operationType 操作类型
 * @param {*} params.amount 金额
 * @returns 
 */
export const addOrReduceMoney = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/deduct`,
    method: 'POST',
    data: params
  })
}
/**
 * 
 * @param {*} id 费用单id
 * @returns 
 */
export const deleteOrReduceMoney = (id) => {
    console.log('merchants.js ~ line: 26 ~ id ->', id);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/deduct/${id}`,
    method: 'DELETE',
  })
}
export const getGoodList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/goodList/` + params,
    method: "GET",
  });
}
// 搜索监理
export const findBindEngineer = (params) => {
  params = parseParam(params)
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineer?` + params,
      method: 'GET'
  })
}
// 指派监理
export const addBindEngineer = (params) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/waterproof`,
      method: 'POST',
      data: params
  })
}
// 获取监理列表
export const findEngineer = (params) => {
  params = parseParam(params)
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order?` + params,
      method: 'GET'
  })
}
export const getAgentList = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/accountGroup/agent`,
    method: "GET",
  });
};
export const downloadExcelActualArea = (params) => {
  params = parseParam(params);
  return request({
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelAreaConfigWaterproof?`+ params,
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofFinance?`+ params,
    method: "GET",
    responseType: "blob",
  });
};
// downloadExcelWaterproofDelivery - 交付防水Excel下载
export const downloadExcelWaterproofDelivery = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofDelivery?` + params,
    method: "GET",
    responseType: "blob",
  });
};
export const addAreaconfigEd = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_delivery_order/addAreaConfigAdded?declarationId=` + data.declarationId,
    method: "POST",
    data: data.otherList,
  });
}
export const addAreaConfig = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_delivery_order/addAreaConfig?declarationId=` + data.declarationId,
    method: "POST",
    data: data.areaConfigList,
  });
}
// 费用单列表
export const findCustomsDeclaration = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_customs_declaration/costDetails/` + params,
    method: "GET",
  });
};
// 面积配置列表
export const getAreaConfig = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/area_details`,
    method: "GET",
    params
  });
};
//getDeliveryOrder
export const getDeliveryOrder = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order/infoV3?id=` + params,
    method: "GET",
  }); 
}
// 生成验收单
export const createAcceptanceOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/order`,
    method: "POST",
    data: data,
  });
};
// updateAcceptanceOrder
export const updateAcceptanceOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/update`,
    method: "PUT",
    data: data,
  });
};
//退回原因
export const passOrRefused = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
      method: 'PUT',
      data: data
  })
}
// passOrRefused
export const passOrRefusedV2 = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/updateReview`,
      method: 'PUT',
      data: data
  })
}
// passOrRefusedAcceptance
export const passOrRefusedAcceptance = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/update`,
      method: 'PUT',
      data: data
  })
}
// passOrRefusedAcceptance
export const passOrRefusedAcceptanceV2 = (data) => {
  return request({
      url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/updateReviewV2`,
      method: 'PUT',
      data: data
  })
}
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: "blob",
    data: params,
  });
};
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
export const findWaterProof = (params) => {
  params = parseParam(params);
  params = params + "&type=WATERPROOF";
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?` + params,
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?` + params,
    method: "GET",
  });
};
export const getMerchantOrder = (params) => {
  return request({
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration?id=` + params,
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?id=` + params,
    method: "GET",
  });
};
export const editMerchantOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration`,
    method: "PUT",
    data: data,
  });
};
export const downloadExcelCustomsDeclaration = (params) => {
  params = parseParam(params);
  return request({
    // url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproofCustomsDeclaration?type=WATERPROOF&` + params,
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelWaterproof?type=WATERPROOF&` + params,
    method: "GET",
    responseType: "blob",
  });
};
export const findWaterProofAll = () => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
    method: "GET",
  });
};

export const addWaterProof = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "POST",
    data: data,
  });
};

export const editWaterProof = (data) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent`,
    method: "PUT",
    data: data,
  });
};

export const delWaterProof = (ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/agent/${temp}`,
    method: "DELETE",
  });
};
export const chooseSecondWaterProof = (id) => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
    method: "GET",
  });
};
export const handleRebates = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/audit/${data}`,
  });
};

// 获取防水项目阶段详情
export const getWaterProofStage = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/calculateCostWaterproof/`+id,
    method: "GET",
  });
};
// 修改子工单计费版本（V1/V2 标签）
export const updateOrderCostVersion = (orderId, version) => {
  const v = version === undefined || version === null ? '' : version;
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/costVersion/${orderId}?version=${encodeURIComponent(v)}`,
    method: "PUT",
  });
};
// 按子工单ID查询单工单费用（含 costVersion）
export const calculateCostSingle = (orderId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/calculateCostSingle/${orderId}`,
    method: "GET",
  });
};
// 获取防水项目订单详情
export const getWaterProofOrderInfo = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form/evaluateInfoList/`+id,
    method: "GET",
  });
};
// 防水项目阶段终审操作
export const passOrRefusedStage = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data
  });
};
// 根据报单id获取防水项目阶段详情
export const getWaterProofStageInfo = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/waterProofOrder?declarationId=${id}`,
    method: "GET",
  });
};
// 更新防水项目阶段
export const updateWaterProofStage = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/assign`,
    method: "POST",
    data
  });
};
// 调整阶段计划 / 补录入场·实际完成
// data: { orderId, goodsId, adjustedPlanStart, adjustedPlanEnd, actualStartTime, actualEndTime }
export const adjustStagePlan = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/adjustStagePlan`,
    method: "POST",
    data
  });
};
// 获取可用工程师（按客户期望进场日期与服务区域筛选）
export const getAvailableEngineers = (data) => {
  const params = parseParam(data);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/availableEngineers?` + params,
    method: "GET",
  });
};
// 个人周看板（防水派单-可派单工程师列表接口设计.md §十七）
// GET + RequestBody：需用 request({ method:'get', data:{...} }) 方式携带 body
// data: { engineerUserId(必填), weekStart(周一0点毫秒时间戳，可选，默认本周一) }
export const getEngineerWeekBoard = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_engineer_roster/weekBoard?` + parseParam(data),
    method: "GET",
    data
  });
};
// 删除防水项目阶段
export const delPhaseWaterProofStage = (id, reason) => {
  const encodedReason = encodeURIComponent(reason || '');
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/delPhase/${id}?reason=${encodedReason}`,
    method: "DELETE",
  });
};
// 新增防水项目阶段
export const addPhaseWaterProofStage = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/addPhase?declarationId=${data.declarationId}&goodsId=${data.goodsId}`,
    method: "POST",
  });
};
// 获取阶段配置列表
export const getPhaseList = (rootDepartId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/phase?rootDepartId=${rootDepartId}`,
    method: "GET"
  });
};
// 新增提货单
export const addDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "POST",
    data: data,
  });
};
export const updateDeliveryOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/delivery_order`,
    method: "PUT",
    data: data,
  });
};
//内勤人员点击下一步/joins-sales-cloud/v1/customs_declaration/step
export const putNextStep = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/step`,
    method: "PUT",
    data: data,
  });
};
// 防水报单反审核接口
// payload 可选，包含 reCollect、collectType、type 等扩展字段（如 "WATERPROOF"）
export const reverseReviewWaterProof = (id, payload = {}) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/reverseReview`,
    method: "PUT",
    data: { id, ...payload },
  });
};
// 获取面积电器配置（declarationId 只是参数名，实际传报单ID）
export const getAreaConfigByDeclarationId = (declarationId, declarationFlag) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/area_config/getConfigByDeclarationId?declarationId=${declarationId}&declarationFlag=${declarationFlag}`,
    method: "GET",
  });
};
//防水报单作废接口
export const cancelWaterProof = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/manage_project_order/cancelled?declarationId=${params.declarationId}`,
    method: "POST",
    data: params,
  });
};
// 售后报单
export const addAfterSaleOrder = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/after_sales`,
    method: "POST",
    data: data,
  });
};
/**
 * 查询收方表汇总（分享页面数据）
 * @param {String} engineeringOrderId 工单ID
 * @param {String} type 分享类型：NORMAL / SUPPLEMENTARY
 */
export const getSquareVolume = (engineeringOrderId, type) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/area_config/squareVolume/${engineeringOrderId}?type=${type}`,
    method: "GET",
  });
};
// 查询子工单材料兜底审核提示
export const queryMaterialShortage = (orderId) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/engineering_order/materialShortage/${orderId}`,
    method: "GET",
  });
};